// src/YearAccordionSchema.js
import { advancedListingSchema } from './AdvancedListingSchema';

export const YearAccordionSchema = (props) => {
  const base = advancedListingSchema(props);

  const extra = {
    fieldsets: [
      {
        id: 'yearAccordion',
        title: 'Year and accordion',
        fields: ['accordionTagGroups', 'accordionDefaultOpen', 'groupUnmatchedUnder'],
      },
    ],
    properties: {
      accordionTagGroups: {
        title: 'Accordion sections by tags',
        widget: 'textarea',
        description:
          'One mapping per line:\n' +
          'News: news\n' +
          'Resources: |pdf, download, guide\n' +
          'Events: event\n' +
          'Case-insensitive. Matches item subjects/tags.',
      },
      accordionDefaultOpen: {
        title: 'Open first year by default',
        type: 'boolean',
        default: true,
      },
      groupUnmatchedUnder: {
        title: 'Header for unmatched items',
        description: 'If set, items without matching tags appear here. Leave empty to hide.',
      },
    },
  };

  return {
    ...base,
    fieldsets: [...base.fieldsets, ...extra.fieldsets],
    properties: { ...base.properties, ...extra.properties },
  };
};
